import { ConfigProvider } from "antd";
import esES from "antd/lib/locale/es_ES";
import { jwtDecode } from "jwt-decode";
import Login from "pages/Login";
import Manager from "pages/Manager";
import Rules from "pages/Manager/Rules";
import RuleForm from "pages/Manager/Rules/Form";
import AdminTenders from "pages/Manager/Tenders";
import TendersForm from "pages/Manager/Tenders/Form";
import Reviewer from "pages/Reviewer";
import ModelValidator from "pages/Reviewer/Validation";
import ReviewerTenders from "pages/Reviewer/Tenders";
import TendersView from "pages/Reviewer/Tenders/Form";
import React, { useCallback, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "./index.less";

const Site = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isReviewer, setIsReviewer] = useState(false);
  const [loading, setLoading] = useState(true);

  const redirect = useCallback(() => {
    try {
      const jwt = sessionStorage.getItem("auth");
      const decoded = jwtDecode(jwt);

      if (decoded.role === "ADMIN") setIsAdmin(true);

      if (decoded.role === "REVIEWER") setIsReviewer(true);
    } catch {
    } finally {
      setLoading(false);
    }
  }, [setIsAdmin, setIsReviewer]);

  useEffect(() => {
    redirect();
  }, [redirect]);

  if (loading) return null;
  return (
    <ConfigProvider 
      locale={esES}
      theme={{
        token: {
          colorPrimary: "#052e4d",
          colorInfo: "#ee964b",
          colorSuccess: "#17A398",
          colorError: "#C81D25",
          fontSize: 18,
          
          // Override primary color shades
          colorPrimaryBg: "#e6f0f7",        // Background
          colorPrimaryBgHover: "#bfd9eb",   // Background hover
          colorPrimaryBorder: "#99c2df",    // Border
          colorPrimaryBorderHover: "#73abd3", // Border hover
          colorPrimaryHover: "#084163",     // Hover state
          colorPrimaryActive: "#041f32",    // Active/pressed state
          colorPrimaryTextHover: "#084163", // Text hover
          colorPrimaryText: "#052e4d",      // Text
          colorPrimaryTextActive: "#041f32", // Text active
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route
            path="/reviewer/validate"
            element={!isReviewer ? <Navigate to="/" /> : <ModelValidator />}
          />
          <Route
            path="/reviewer/tenders/view"
            element={!isReviewer ? <Navigate to="/" /> : <TendersView />}
          />
          <Route
            path="/reviewer/tenders"
            element={!isReviewer ? <Navigate to="/" /> : <ReviewerTenders />}
          />
          <Route
            path="/reviewer"
            element={!isReviewer ? <Navigate to="/" /> : <Reviewer />}
          />
          <Route
            path="/manager/rules/edit"
            element={!isAdmin ? <Navigate to="/" /> : <RuleForm />}
          />
          <Route
            path="/manager/rules/new"
            element={!isAdmin ? <Navigate to="/" /> : <RuleForm />}
          />
          <Route
            path="/manager/rules"
            element={!isAdmin ? <Navigate to="/" /> : <Rules />}
          />
          <Route
            path="/manager/tenders/edit"
            element={!isAdmin ? <Navigate to="/" /> : <TendersForm />}
          />
          <Route
            path="/manager/tenders/new"
            element={!isAdmin ? <Navigate to="/" /> : <TendersForm />}
          />
          <Route
            path="/manager/tenders"
            element={!isAdmin ? <Navigate to="/" /> : <AdminTenders />}
          />
          <Route
            path="/manager"
            element={!isAdmin ? <Navigate to="/" /> : <Manager />}
          />
          <Route path="/" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
};

const root = createRoot(document.getElementById("root"));
root.render(<Site />);
